import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  Button,
  Box,
  Typography
} from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

// واجهة بيانات الفلتر
interface FilterData {
  barcode: string;
  productName: string;
  variantName: string;
  warehouse: string;
  dateFrom: string;
  dateTo: string;
}

// خصائص مكون الفلتر
interface InventoryMovementFilterProps {
  filterValues: FilterData;
  warehouses: string[];
  onFilterChange: (values: FilterData) => void;
}

// مكون فلتر تقرير حركة المخزون
const InventoryMovementFilter: React.FC<InventoryMovementFilterProps> = ({
  filterValues,
  warehouses,
  onFilterChange
}) => {
  // نسخة محلية من قيم الفلتر للتعديل
  const [localFilterValues, setLocalFilterValues] = React.useState<FilterData>(filterValues);

  // معالجة تغيير قيم الفلتر المحلية للحقول النصية
  const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name) {
      setLocalFilterValues(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // معالجة تغيير قيم القائمة المنسدلة
  const handleSelectChange = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    if (name) {
      setLocalFilterValues(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // تطبيق الفلتر
  const applyFilter = () => {
    onFilterChange(localFilterValues);
  };

  // إعادة تعيين الفلتر
  const resetFilter = () => {
    const resetValues: FilterData = {
      barcode: '',
      productName: '',
      variantName: '',
      warehouse: '',
      dateFrom: '',
      dateTo: ''
    };
    setLocalFilterValues(resetValues);
    onFilterChange(resetValues);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {/* حقل الباركود */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="باركود المتغير"
            name="barcode"
            value={localFilterValues.barcode}
            onChange={handleTextFieldChange}
            variant="outlined"
            size="small"
          />
        </Grid>

        {/* حقل اسم المنتج */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="اسم المنتج"
            name="productName"
            value={localFilterValues.productName}
            onChange={handleTextFieldChange}
            variant="outlined"
            size="small"
          />
        </Grid>

        {/* حقل اسم المتغير */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="اسم المتغير"
            name="variantName"
            value={localFilterValues.variantName}
            onChange={handleTextFieldChange}
            variant="outlined"
            size="small"
          />
        </Grid>

        {/* قائمة المستودعات */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth size="small" variant="outlined">
            <InputLabel>المستودع</InputLabel>
            <Select
              name="warehouse"
              value={localFilterValues.warehouse}
              onChange={handleSelectChange}
              label="المستودع"
            >
              <MenuItem value="">
                <em>الكل</em>
              </MenuItem>
              {warehouses.map((warehouse, index) => (
                <MenuItem key={index} value={warehouse}>
                  {warehouse}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* حقل التاريخ (من) */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            type="date"
            label="من تاريخ"
            name="dateFrom"
            value={localFilterValues.dateFrom}
            onChange={handleTextFieldChange}
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* حقل التاريخ (إلى) */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            type="date"
            label="إلى تاريخ"
            name="dateTo"
            value={localFilterValues.dateTo}
            onChange={handleTextFieldChange}
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* أزرار التحكم */}
        <Grid item xs={12} sm={12} md={4} lg={6} sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={applyFilter}
            sx={{
              bgcolor: '#30c3b0',
              '&:hover': { bgcolor: '#25a899' },
              boxShadow: '0 4px 12px rgba(48, 195, 176, 0.2)',
            }}
          >
            بحث
          </Button>
          <Button
            variant="outlined"
            color="error"
            startIcon={<ClearIcon />}
            onClick={resetFilter}
          >
            إعادة تعيين
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InventoryMovementFilter;